import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ColorPickerDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../types";
import {
    getFocusRingStyle
} from "../../helpers/theme/state";
import {
    getCornerStyle
} from "../../helpers/theme/corner";
import {
    webStyle
} from "../../utils";

export const getColorPickerGapStyle = (gap: number): ViewStyle => {
    return {
        gap
    };
};

export const useStyles = ({
    spreadBehaviour,
    isFocusVisible,
    shapeConfigs,
    isAreaFlush,
    previewSize,
    radiuses,
    borders,
    colors,
    spaces,
    width
}: ColorPickerDynamicStyleType) => {
    const padding = spaces.spacingMd - spaces.spacingXs;

    const container = {
        width: spreadBehaviour === "stretch" ? "100%" : width
    } as Mutable<ViewStyle>;

    const areaContainer = {
        ...isAreaFlush ? {} : {
            paddingHorizontal: padding,
            paddingTop: padding
        }
    } as Mutable<ViewStyle>;

    const contentContainer = {
        gap: padding,
        padding
    } as Mutable<ViewStyle>;

    const separatorContainer = {
        marginHorizontal: -padding
    } as Mutable<ViewStyle>;

    const sliderColumn = {
        gap: spaces.spacingSm
    } as Mutable<ViewStyle>;

    const topRow = {
        gap: padding
    } as Mutable<ViewStyle>;

    const preview = {
        ...getFocusRingStyle({
            colorKey: "default",
            isFocusVisible,
            borders,
            colors
        }),
        ...getCornerStyle({
            radius: radiuses.full,
            shapeConfigs
        }),
        height: previewSize,
        width: previewSize
    } as Mutable<ViewStyle>;

    const previewHalf = {
        width: previewSize / 2,
        height: previewSize
    } as Mutable<ViewStyle>;

    const previewCurrentSwatch = {
        marginStart: -previewSize / 2
    } as Mutable<ViewStyle>;

    const presetGroup = {
        gap: spaces.spacingSm
    } as Mutable<ViewStyle>;

    return {
        previewCurrentSwatch,
        separatorContainer,
        contentContainer,
        areaContainer,
        sliderColumn,
        presetGroup,
        previewHalf,
        container,
        preview,
        topRow
    };
};

const stylesheet = StyleSheet.create({
    formatRow: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row"
    },
    preview: {
        flexDirection: "row",
        overflow: "hidden",
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    sliderColumn: {
        justifyContent: "center",
        flex: 1
    },
    fieldsRow: {
        alignItems: "center",
        flexDirection: "row"
    },
    contrastRow: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    topRow: {
        alignItems: "center",
        flexDirection: "row"
    },
    separatorContainer: {
        alignSelf: "stretch"
    },
    contrastContainer: {
        alignSelf: "stretch"
    },
    hintContainer: {
        alignSelf: "stretch"
    },
    previewHalf: {
        overflow: "hidden"
    },
    ratio: {
        fontVariant: [
            "tabular-nums"
        ]
    },
    fieldsInputs: {
        flex: 1
    }
});

export default stylesheet;
